import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { FocusPayApplication } from "src/app/shared/models/FocusPay/FocusPayApplication.item";
import { ApplicationSingleViewComponent } from "./application-single-view/application-single-view.component";

@Component({
	selector: "app-application-status",
	templateUrl: "./application-status.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ApplicationStatusComponent implements OnInit {
	@ViewChild("applicationSingleView") applicationSingleView: ApplicationSingleViewComponent;
	applicationList: FocusPayApplication[];
	applicationIdSelected: string;
	applicationIdStatus: string;

	constructor(public app: AppService, private userService: UserService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async load() {}

	createDeal() {}

	newApplication() {}
}
